export function parseFilterQuery(search) {
  const params = new URLSearchParams(search);

  const get = (key) => {
    const v = params.get(key);
    return v ? Number(v) : null;
  };

  return {
    kategorie: get("kategorie"),
    ablageort: get("ablageort"),
    typ: get("typ"),
    land: get("land"),
    material: get("material"),
    waehrung: get("waehrung"),
    zustand: get("zustand"),
    eigentuemer: get("eigentuemer"),
    jahrgangMin: params.get("jahrgang_min"),
    jahrgangMax: params.get("jahrgang_max"),
  };
}
